import Image from "./../image";
import ImageButton from "../button/image-button";
import { Language } from "../../types/language";
import { useAudioStore } from "@/store/audioStore";
import { useTranslation } from "react-i18next";
import { useLanguageStore } from "@/store/languageStore";
import { CHAT_TYPE } from "@/types/navigation-mode";

interface LanguageSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  languageList: Language[];
  type: string;
}

const VoiceSelector: React.FC<LanguageSelectorProps> = ({
  isOpen,
  onClose,
  languageList,
  type,
}) => {
  const setVoice = useAudioStore((s) => s.setVoice);
  const audioVoice = useAudioStore((s) => s.audioVoice);
  // const currentVoice = audioVoice;

  const setSelectedVoiceName = useLanguageStore((s) => s.setSelectedVoiceName);
  const selectedVoiceName = useLanguageStore((s) => s.selectedVoiceName);
  const currentVoice =
    type == CHAT_TYPE.NAVIGATION ? selectedVoiceName : audioVoice;
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleLanguageSelect = (voice: string) => {
    if (CHAT_TYPE.NAVIGATION === type) {
      setSelectedVoiceName(voice);
    } else {
      setVoice(voice);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-paper-gray rounded-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center mb-4 px-[20px] pt-[20px]">
          <h2 className="text-xl font-semibold primary-text-color">
            {t("voice")}
          </h2>
          <ImageButton
            onClick={onClose}
            src="/assets/icon_close.png"
            alt="selected"
            size={20}
            className="text-gray-500 hover:text-gray-700"
          />
        </div>

        <div className="flex-1 overflow-y-auto">
          {languageList.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageSelect(language.code)}
              className={`px-[20px] w-full text-left p-3 rounded flex items-center justify-between ${
                currentVoice === language.name ? "bg-green-light" : ""
              }`}
            >
              <div className="font-medium primary-text-color">
                {language.name}
              </div>
              {currentVoice === language.code ? (
                <Image
                  aria-hidden
                  src="/assets/icon_check.png"
                  alt="selected"
                  width={20}
                  height={20}
                />
              ) : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VoiceSelector;
